import Yup from 'utils/validation';

export const selectWorkflowSchema = Yup.object({
  workflowId: Yup.string().required('Choose a workflow.')
});

export type SelectWorkflowFormData = Yup.InferType<typeof selectWorkflowSchema>;
